<div class="flex flex-col gap-2 bg-slate-100 p-4 rounded-md shadow-md overflow-auto w-[384px] sm:w-[620px] md:w-[748px] lg:w-[1000px]">
    <div class="text-xl font-title font-bold">
        @if (id) {
            <a href="/news?id={{ id }}" class="hover:text-ponder-linkhover hover:cursor-pointer">{{ title }}</a>
        } @else {
            {{ title }}
        }
    </div>
    <div class="flex flex-row gap-2 items-center justify-start text-sm border-b border-slate-400 pb-2 text-slate-600">
        <a href="/user/{{ authorUsername! }}"><avatar [username]="authorUsername!" [small]="true"></avatar></a>
        <a href="/user/{{ authorUsername! }}" class="hover:text-ponder-linkhover">by {{ authorDisplayName ?? authorUsername! }} on <span title="{{ createdAt }}">{{ createdAt | date }}</span></a>
        @if (modifiedAt) {
            <div class="text-slate-400 italic">(updated <span title="{{ modifiedAt }}">{{ modifiedAt | date }})</span></div>
        }
    </div>
    <markdown-block [content]="content!" class="min-h-[15vh] text-sm p-2 markdown"></markdown-block>
    @if (truncated) {
        <a href="/news?id={{ id }}" class="hover:text-ponder-linkhover hover:cursor-pointer border border-transparent hover:border-ponder-linkhover p-2 rounded shadow-sm bg-slate-50">
            <div class="text-center">
                Read full post
            </div>
        </a>
    }
</div>